import React from "react";
import styled from "styled-components";
import DistributionPlot from "common/graphs/DistributionPlot";

const ChartTitle = styled.h4`
  margin-top: 0;
  margin-bottom: 0;
`;

export const AppChart = ({
    title,
    data,
    plotMode,
    selection,
    setSelection,
    showMinMax,
  }) => {
    return (
      <div>
        <ChartTitle>{title}</ChartTitle>
        <DistributionPlot
          plotMode={plotMode}
          data={data}
          selection={selection}
          setSelection={setSelection}
          minmax={showMinMax}
        />
      </div>
    );
  };